import React, { useState } from "react";
import { observer } from "mobx-react";


interface ITrueFalseProps {
    optionalContext: string;
    text: string;
    selectedAnswer: boolean | string;
    setSelectedAnswer: Function;
}

let TrueFalse = observer(
    ({
        optionalContext,
        selectedAnswer,
        setSelectedAnswer,
        text
    }: ITrueFalseProps) => {
        return (
            <div>
                <div className="question-type-header">True/False</div>
                {optionalContext && optionalContext.length > 0 ? (
                    <div className="optional-context">{optionalContext}</div>
                ) : (
                    <span></span>
                )}
                <div className="question-text">{text}</div>

                <br />
                <input
                    checked={selectedAnswer === true}
                    onChange={(e: any) => setSelectedAnswer(true)}
                >
                    True
                </input>
                <input
                    checked={selectedAnswer === false}
                    onChange={(e: any) => setSelectedAnswer(false)}
                >
                    False
                </input>
            </div>
        );
    }
);

export default TrueFalse;
